import script from "./BaseTableHeaderInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTableHeaderInfo.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTableHeaderInfo.vue?vue&type=style&index=0&id=68392162&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68392162"]])

export default __exports__